import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import {
  Input,
  Text,
  TextInput,
  Select,
  Button,
  Tooltip,
  Loader,  Modal,
  LoadingOverlay,
} from "@mantine/core";
import { withAuthenticator } from "@aws-amplify/ui-react";
import { useMediaQuery } from "@mantine/hooks";

function ProfileData({ user, signOut }) {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [lastName, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [birthYear, setBirthYear] = useState("");
  const [country, setCountry] = useState("");
  const [updateProfile, setUpdateProfile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [status, setStatus] = useState(0);
  const [changes, setChanges] = useState(false);
  const [opened, setOpened] = useState(false);
  const matches = useMediaQuery("(min-width: 800px)");
  useEffect(() => {
    axios
      .post(
        "https://17eh5s1nff.execute-api.eu-north-1.amazonaws.com/doglass/",
        {},
        {
          headers: {
            Authorization: user.signInUserSession.idToken.jwtToken,
          },
        }
      )
      .then((res) => {
        setEmail(res.data.email);
        setFirstName(res.data.first_name);
        setLastName(res.data.last_name);
        setGender(res.data.gender);
        setBirthYear(res.data.birth_year);
        setCountry(res.data.country);
        setUpdateProfile(false);
        setLoading(true);
      });
  }, [updateProfile]);

  const deleteUser = () => {
    axios
      .post(
        "https://t0eze4md20.execute-api.eu-north-1.amazonaws.com/delete-user",
        {},
        {
          headers: {
            Authorization: user.signInUserSession.idToken.jwtToken,
          },
        }
      )
      .then((res) => {signOut()});
  };

  const editProfile = () => {
    axios
      .post(
        "https://wsuul5o3gd.execute-api.eu-north-1.amazonaws.com/update-profile-streamer/",
        {
          first_name: firstName,
          last_name: lastName,
          gender: gender,
          birth_year: birthYear,
          country: country,
        },
        {
          headers: {
            Authorization: user.signInUserSession.idToken.jwtToken,
          },
        }
      )
      .then((res) => {
        setUpdateProfile(true);
        setVisible(false);
        setStatus(res.status);
      });
  };

  return (
    <div style={{ width: "80%", padding: 20 }}>
      <LoadingOverlay visible={visible} overlayBlur={2} />
      <Text size={24} weight={600} mb={"1rem"}>
        Edit Profile
      </Text>
      <div>
        <Text color="dimmed">Registered Email</Text>
        <Input
          icon={loading == true ? "" : <Loader size="xs" />}
          style={{ maxWidth: "39rem" }}
          mt={5}
          mb={10}
          variant="filled"
          size="md"
          value={email}
          disabled
        />
        <div style={{ display: matches ? "flex" : "block", maxWidth: "40rem", marginTop: 10 }}>
          <div style={{ display: "block", width: "100%" }}>
            <Text style={{ width: "15rem" }} color="dimmed">
              First Name
            </Text>
            <TextInput
              style={{ width: "15rem" }}
              mt={5}
              mb={10}
              size="md"
              icon={loading == true ? "" : <Loader size="xs" />}
              variant="filled"
              value={loading == true ? firstName : ""}
              onChange={(event) => {
                setFirstName(event.currentTarget.value);
                setChanges(true);
              }}
            />
          </div>
          <div style={{ display: "block", width: "100%" }}>
            <Text style={{ width: "15rem" }} color="dimmed">
              Last Name
            </Text>
            <Input
              style={{ width: "15rem" }}
              mt={5}
              mb={10}
              variant="filled"
              icon={loading == true ? "" : <Loader size="xs" />}
              size="md"
              value={loading == true ? lastName : ""}
              onChange={(event) => {
                setLastName(event.currentTarget.value);
                setChanges(true);
              }}
            />
          </div>
        </div>

        <div style={{ display: matches ? "flex" : "block", maxWidth: "40rem", marginTop: 10 }}>
          <div style={{ display: "block", width: "100%" }}>
            <Text style={{ width: "15rem" }} color="dimmed">
              Gender
            </Text>
            <Select
              style={{ width: "15rem" }}
              mt={5}
              mb={10}
              variant="filled"
              size="md"
              icon={loading == true ? "" : <Loader size="xs" />}
              data={[
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" },
                { value: "Other", label: "Other" },
              ]}
              value={gender}
              onChange={(event) => {
                setGender(event);
                setChanges(true);
              }}
            />
          </div>
          <div style={{ display: "block", width: "100%" }}>
            <Text style={{ width: "15rem" }} color="dimmed">
              Birth Year
            </Text>
            <TextInput
              style={{ width: "15rem" }}
              mt={5}
              mb={10}
              maxLength={4}
              variant="filled"
              size="md"
              icon={loading == true ? "" : <Loader size="xs" />}
              value={birthYear}
              onChange={(event) => {
                setBirthYear(event.currentTarget.value);
                setChanges(true);
              }}
            />
          </div>
        </div>
        <Text color="dimmed" mt={10}>
          Country
        </Text>
        <Select
          style={{ maxWidth: "35rem" }}
          mt={5}
          mb={10}
          size="md"
          variant="filled"
          icon={loading == true ? "" : <Loader size="xs" />}
          data={[
            { value: "Sweden", label: "Sweden" },
            { value: "Denmark", label: "Denmark" },
            { value: "Norway", label: "Norway" },
            { value: "Finland", label: "Finland" },
            { value: "Germany", label: "Germany" },
            { value: "Poland", label: "Poland" },
            { value: "UK", label: "United Kingdom" },
            { value: "USA", label: "United States" },
          ]}
          value={country}
          onChange={(event) => {
            setCountry(event);
            setChanges(true);
          }}
        />
      </div>
      <div
        style={{
          display: matches ? "flex" : "block",
          justifyContent: "space-between",
          maxWidth: "40rem",
          marginTop: "2rem",
        }}
      >
                  {changes == true ? 
        <Button
          color={status == 200 ? "green" : "blue"}
          onClick={() => {
            editProfile();
            setVisible((v) => !v);
            setChanges(true);
          }}
        >
          {status == 200 ? <div>Successfully Saved</div> : <div>Save Changes</div>}
        </Button>
        : <Button disabled>Save Changes</Button>}
          <Button
            variant="subtle"
            onClick={() => {
              // window.location = "mailto:hampusforsling@adly.gg"
              setOpened(true);
            }}
          >
            Delete Account
          </Button>
      </div>
      <Modal
            size={450}
            opened={opened}
            onClose={() => setOpened(false)}
            overflow="outside"
            lockScroll
            transitionDuration={500}
            transitionTimingFunction="ease-in-out"
          >
            <div>
            <Text size="lg" weight="bold">Delete Account</Text>
            <Text size="16px">Are you sure that you want to permanently delete your account?</Text>
            <Button m="sm" ml="0px" onClick={()=> setOpened(false)}>No</Button>
            <Button m="sm"  onClick={()=> deleteUser()}>Yes, Delete</Button>

            </div>
          </Modal>
    </div>
  );
}

export default withAuthenticator(ProfileData);
